import { MessageCircle, Star, Zap } from "lucide-react";
import { Button } from "@/components/ui/button";
import LazyVideo from "./LazyVideo";
const HOTMART_CHECKOUT_URL = "https://pay.hotmart.com/X103718093T?checkoutMode=10";
const testimonials = [{
  platform: "whatsapp",
  time: "12:30 PM",
  name: "María G.",
  location: "Miami, FL",
  initials: "MG",
  quote: "De 580 a 720 en 6 meses. ¡Funciona! Refinancié mi auto y ahorro $280/mes.",
  result: "+140 puntos"
}, {
  platform: "facebook",
  time: "2 días",
  name: "Carlos R.",
  location: "Houston, TX",
  initials: "CR",
  quote: "Aprobé mi primera tarjeta con $5,000 límite después de años de rechazos.",
  result: "Primera tarjeta aprobada"
}, {
  platform: "instagram",
  time: "1 semana",
  name: "José L.",
  location: "Los Angeles, CA",
  initials: "JL",
  quote: "ITIN → 750 en 18 meses. Ahora ayudo a mi familia con sus créditos. #CréditoLibre",
  result: "750 score con ITIN"
}, {
  platform: "whatsapp",
  time: "9:15 AM",
  name: "Ana R.",
  location: "New York, NY",
  initials: "AR",
  quote: "Refinancié mi auto de 22% a 4.9% de interés. Me ahorro $200 al mes gracias al crédito.",
  result: "De 22% a 4.9% APR"
}, {
  platform: "email",
  time: "Ayer",
  name: "Sofía M.",
  location: "Phoenix, AZ",
  initials: "SM",
  quote: "Por fin pude alquilar el apartamento que quería. Antes me rechazaban por mi crédito.",
  result: "Apartamento aprobado"
}, {
  platform: "facebook",
  time: "3 días",
  name: "Pedro S.",
  location: "Las Vegas, NV",
  initials: "PS",
  quote: "Las empresas me cobraron $1,200 y no hicieron nada. Esto por $16.99 sí funcionó.",
  result: "Ahorró $1,200+"
}];
const getPlatformStyles = (platform: string) => {
  const styles: Record<string, {
    bg: string;
    icon: string;
    text: string;
  }> = {
    whatsapp: {
      bg: "bg-[hsl(142_70%_45%)]",
      icon: "💬",
      text: "WhatsApp"
    },
    facebook: {
      bg: "bg-[hsl(214_60%_45%)]",
      icon: "📘",
      text: "Facebook"
    },
    instagram: {
      bg: "bg-gradient-to-r from-[#f09433] via-[#dc2743] to-[#bc1888]",
      icon: "📸",
      text: "Instagram"
    },
    email: {
      bg: "bg-secondary",
      icon: "✉️",
      text: "Email"
    }
  };
  return styles[platform] || styles.email;
};
const TestimonialsSection = () => {
  const handleBuyClick = () => {
    window.open(HOTMART_CHECKOUT_URL, "_blank");
  };
  return <section className="relative overflow-hidden section-padding bg-[hsl(215,12%,40%)]">
      {/* Background dots pattern */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute inset-0" style={{
        backgroundImage: `radial-gradient(circle, rgba(255,255,255,0.3) 1px, transparent 1px)`,
        backgroundSize: '20px 20px'
      }} />
      </div>
      <div className="container-centered relative z-10">
        {/* Section Header */}
        <div className="mb-12 text-center">
          <div className="mb-4 inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-teal-500 via-cyan-400 to-amber-500 px-4 py-2">
            <MessageCircle className="h-5 w-5 text-slate-900" />
            <span className="text-sm font-semibold text-slate-900">Testimonios Reales</span>
          </div>
          <h2 className="font-display text-2xl font-bold text-foreground sm:text-3xl lg:text-4xl">
            Testimonios Reales de Nuestra{" "}
            <span className="bg-gradient-to-r from-teal-400 via-cyan-300 to-amber-400 bg-clip-text text-transparent">Comunidad</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-primary-foreground font-bold">
            Historias reales de latinos que transformaron su crédito con nuestro sistema
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {testimonials.map((testimonial, index) => {
          const platformStyle = getPlatformStyles(testimonial.platform);
          return <div key={index} className="testimonial-card group overflow-hidden">
                {/* Platform Header */}
                <div className={`${platformStyle.bg} px-4 py-2 flex items-center gap-2`}>
                  <span className="text-sm text-secondary-foreground">{platformStyle.icon} {platformStyle.text}</span>
                  <span className="text-xs ml-auto text-secondary-foreground">• {testimonial.time}</span>
                </div>

                <div className="p-5">
                  {/* Quote */}
                  <blockquote className="mb-4 leading-relaxed text-secondary-foreground">
                    "{testimonial.quote}"
                  </blockquote>

                  {/* Result Badge */}
                  <div className="mb-4 inline-block rounded-full bg-gradient-to-r from-teal-500/20 via-cyan-400/20 to-amber-500/20 px-3 py-1 text-sm font-semibold text-cyan-400">
                    ✓ {testimonial.result}
                  </div>

                  {/* Author */}
                  <div className="flex items-center gap-3 border-t border-border pt-4">
                    <div className="flex h-10 w-10 items-center justify-center rounded-full bg-secondary text-secondary-foreground font-bold text-sm">
                      {testimonial.initials}
                    </div>
                    <div>
                      <p className="font-semibold bg-gradient-to-r from-teal-400 via-cyan-300 to-amber-400 bg-clip-text text-transparent">{testimonial.name}</p>
                      <p className="text-sm text-muted-foreground">{testimonial.location}</p>
                    </div>
                  </div>
                </div>
              </div>;
        })}
        </div>


        {/* Social Proof Bar */}
        <div className="mt-10 flex flex-wrap items-center justify-center gap-6 rounded-2xl bg-card p-6 shadow-card sm:gap-10">
          <div className="text-center">
            <p className="font-display text-3xl font-bold bg-gradient-to-r from-teal-400 via-cyan-300 to-amber-400 bg-clip-text text-transparent">1547+</p>
            <p className="text-sm text-muted-foreground font-bold">Latinos Exitosos</p>
          </div>
          <div className="hidden sm:block h-10 w-px bg-border" />
          <div className="text-center">
            <div className="flex justify-center gap-1 mb-1">
              {[...Array(5)].map((_, i) => <Star key={i} className="h-4 w-4 fill-accent text-accent" />)}
            </div>
            <p className="text-sm text-muted-foreground font-bold">4.9/5 Calificación</p>
          </div>
          <div className="hidden sm:block h-10 w-px bg-border" />
          <div className="text-center">
            <p className="font-display text-3xl font-bold bg-gradient-to-r from-teal-400 via-cyan-300 to-amber-400 bg-clip-text text-transparent">+120</p>
            <p className="text-sm text-muted-foreground font-bold">Puntos Promedio</p>
          </div>
        </div>

        {/* Disclaimer */}
        <p className="mt-6 text-center text-sm text-muted-foreground">
          🔒 Resultados reales de personas reales. Cada caso es distinto, pero el sistema es el mismo.
        </p>

        {/* CTA después de testimonios */}
        <div className="mt-10 btn-container">
          <p className="mb-4 text-lg font-semibold text-primary-foreground">
            🎯 ¡El siguiente caso de éxito puedes ser TÚ!
          </p>
          <Button onClick={handleBuyClick} size="lg" className="btn-cta relative h-14 bg-gradient-to-r from-teal-500 via-cyan-400 to-amber-500 px-8 text-base font-bold text-slate-900 shadow-[0_0_30px_rgba(20,184,166,0.4)] transition-all hover:scale-105 animate-pulse-glow sm:h-16 sm:px-12 sm:text-lg">
            <Zap className="mr-2 h-5 w-5 flex-shrink-0" />
            <span className="text-center whitespace-normal">¡TRANSFORMAR MI CRÉDITO HOY! - $16.99</span>
          </Button>
        </div>
      </div>
    </section>;
};
export default TestimonialsSection;